import React, { useEffect, useState } from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Paper, CircularProgress } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { Save, Cancel } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import DeckForm from './DeckForm';
import { closeEditCardDeck, saveCardDeck } from '../../../actions/cardDeckActions';
import { fetchAllCategories } from "../../../actions/categoryActions";
import LoadingBackdrop from '../../Common/LoadingBackdrop';
import { fetchAllSubCategories } from '../../../actions/subcategoryActions';
import MainContentContainer from '../../MainContentContainer/MainContentContainer';
import { apiV2 } from '../../../actions/index';

const DEFAULT_DECK = {
  name: '',
  description: '',
  category_id: '',
  primary_color_hex: '#FFFFFF',
  module_description: '',
  module_image_url: '',
  header_image_url: '',
  wrapper_image_url: '',
  search_result_image_url: '',
  share_link_description: '',
  share_image_url: '',
  purchase_store_text: '',
  purchase_store_url: '',
  see_all_description: '',
  sort_order: 0,
  free_view_limit: 1,
  is_premium: true,
  is_active: false,
};

function AddEditCardDeck() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const [deck, setDeck] = useState(DEFAULT_DECK);
  const [fetchLoading, setFetchLoading] = useState(!!id);
  const [saveLoading, setSaveLoading] = useState(false);

  useEffect(() => {
    if (id) {
      setFetchLoading(true);
      apiV2.get(`/decks/${id}`)
        .then((response) => {
          setDeck(response.data);
        })
        .catch(() => {
          navigate('/card-decks');
        })
        .finally(() => {
          setFetchLoading(false);
        });
    }
  }, [id]);

  useEffect(() => {
    dispatch(fetchAllCategories());
    dispatch(fetchAllSubCategories());
  }, [dispatch]);

  const handleSave = () => {
    setSaveLoading(true);
    dispatch(saveCardDeck(
      deck,
      () => {
        setSaveLoading(false);
        navigate('/card-decks');
      },
      () => {
        setSaveLoading(false);
      }
    ));
  };

  const handleCancel = () => {
    dispatch(closeEditCardDeck(() => navigate('/card-decks')));
  };

  const isLoading = fetchLoading || saveLoading;

  return (
    <MainContentContainer sx={{ paddingBottom: 4 }}>
      <LoadingBackdrop open={isLoading} />
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {id && deck ? `Edit Deck: ${deck.name}` : 'Create New Deck'}
          </Typography>
          <Button color="success" onClick={handleSave} startIcon={<Save />} variant="contained" sx={{ marginRight: 2 }}>
            Save
          </Button>
          <Button color="error" startIcon={<Cancel />} variant="contained" onClick={handleCancel}>
            Cancel
          </Button>
        </Toolbar>
      </AppBar>
      {fetchLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 2 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box gap={4}>
          <Paper sx={{ padding: 2 }}>
            {deck && <DeckForm deck={deck} setDeck={setDeck} />}
          </Paper>
        </Box>
      )}
    </MainContentContainer>
  );
}

export default AddEditCardDeck;
